import { styled } from '@volkswagen-onehub/components-core';

interface TextProps {
  size?: string;
  letterSpacing?: string;
}

export const LatinoBlackTitle = styled.h1<TextProps>`
  font-family: 'LatinoTypeVersusBlack';
  color: white;
  font-weight: bold;
  font-size: ${(props)=> props.size ? props.size : '24px'};
  letter-spacing: ${(props)=> props.letterSpacing ? props.letterSpacing : '0.10em'};
  margin: 0;
  @media screen and (min-width: 560px) {
    font-size: ${(props)=> props.size ? props.size : 'var(--textappearances-headline350-fontsize)'};
    letter-spacing: ${(props)=> props.letterSpacing ? props.letterSpacing : '0.22em'};
  }
  @media screen and (min-width: 960px) {
    font-size: ${(props)=> props.size ? props.size : 'var(--textappearances-headline400-fontsize)'};
  }
  @media screen and (min-width: 1280px) {
    font-size: ${(props)=> props.size ? props.size : 'var(--textappearances-headline450-fontsize)'};
  }
  @media screen and (min-width: 1920px) {
    font-size: ${(props)=> props.size ? props.size : 'var(--textappearances-headline500-fontsize)'};
  }
`;

export const LatinoTitleBold = styled.h1`
  font-family: 'LatinoTypeVersusBold';
  color: white;
  font-weight: bold;
  font-size: var(--textappearances-headline400-fontsize);
  margin: 0;

  @media screen and (min-width: 560px) {
    font-size: var(--textappearances-headline350-fontsize);   
  }
  @media screen and (min-width: 960px) {
    font-size: var(--textappearances-headline400-fontsize);   
  }
  @media screen and (min-width: 1280px) {
    font-size: var(--textappearances-headline450-fontsize);
  }
  @media screen and (min-width: 1920px) {
    font-size: var(--textappearances-headline500-fontsize);
  }
`;
